import { FOOD_ITEM_INPUT_SELECTOR } from 'common/FoodUtils';
import { FoodType } from 'src/gqlReactTypings.generated.d';
import {
  DishTypeAppetizer,
  DishTypeBeverage,
  DishTypeDessert,
  DishTypeKids,
  DishTypeMain,
  DishTypeSide,
} from 'src/shared/design-system/Icon';

export const APPETIZER = {
  icon: DishTypeAppetizer,
  label: 'Appetizer',
  value: FoodType.Appetizer,
  dataTest: FOOD_ITEM_INPUT_SELECTOR.FOOD_TYPE.APPETIZER,
};

export const BEVERAGE = {
  icon: DishTypeBeverage,
  label: 'Beverage',
  value: FoodType.Beverage,
  dataTest: FOOD_ITEM_INPUT_SELECTOR.FOOD_TYPE.BEVERAGE,
};

export const DESSERT = {
  icon: DishTypeDessert,
  label: 'Dessert',
  value: FoodType.Dessert,
  dataTest: FOOD_ITEM_INPUT_SELECTOR.FOOD_TYPE.DESSERT,
};

export const KIDS = {
  icon: DishTypeKids,
  label: 'Kids',
  value: FoodType.Kids,
  dataTest: FOOD_ITEM_INPUT_SELECTOR.FOOD_TYPE.KIDS,
};

export const MAIN = {
  icon: DishTypeMain,
  label: 'Main',
  value: FoodType.Main,
  dataTest: FOOD_ITEM_INPUT_SELECTOR.FOOD_TYPE.MAIN,
};

export const SIDE = {
  icon: DishTypeSide,
  label: 'Side',
  value: FoodType.Side,
  dataTest: FOOD_ITEM_INPUT_SELECTOR.FOOD_TYPE.SIDE,
};

export const MAIN_NEED_SIDE_TEXT = {
  title: 'Does this main need a side?',
  description:
    'Let us know if the customer needs to purchase a side item (e.g. rice, bread or a vegatable) separately for this dish.',
};
